import Splide from '@splidejs/splide';

(($, Drupal) => {
  const initFullWidthCarousel = (el) => {
    const slides = $(el).find('.splide__slide');

    const moving = $(el).hasClass('carousel--slider') ? 'slide' : 'fade';

    const slider = new Splide(el, {
      type: moving,
      perPage: 1,
      drag: true,
      arrows: true,
      pagination: true,
      trimSpace: true,
      focus: 'center',
      autoWidth: true,
      autoHeight: true,
      gap: '3rem',
      speed: 600,
      mediaQuery: 'min',
      classes: {
        arrows: 'splide__arrows',
        arrow: 'splide__arrow btn btn--icon-filled',
        prev: 'splide__arrow--prev btn--icon-chevron-left',
        next: 'splide__arrow--next btn--icon-chevron-right',
      },
      breakpoints: {
        320: {
          drag: true,
          pagination: true,
          arrows: false,
          gap: 0,
          perPage: 1,
        },
        768: {
          drag: true,
          pagination: true,
          gap: 0,
          arrows: true,
        },
      },
    });

    const updateHeight = () => {
      const { slide } = slider.Components.Slides.getAt(slider.index);

      if ($(el).hasClass('heroes')) {
        const contentHeight = $(slide).find('.hero').outerHeight(true);
        $(slide.parentElement).css({
          height: `${contentHeight}px`,
          transition: 'height 250ms ease-in-out',
        });
      }
    };
    slider.on('mounted', () => {
      const { slide } = slider.Components.Slides.getAt(slider.index);
      const videos = $(slide).find('video');
      if (videos.length) {
        $(videos).on('loadeddata', updateHeight);
      } else {
        updateHeight();
      }
    });

    slider.on('mounted move', () => {
      const arrowPrev = $(el).find('.splide__arrow--prev');
      const arrowNext = $(el).find('.splide__arrow--next');

      $(arrowNext).removeClass('active');
      $(arrowPrev).removeClass('active');

      if (slider.index === 0) {
        $(arrowPrev).addClass('hidden');
      } else {
        $(arrowPrev).removeClass('hidden');
      }

      if (slider.index === slides.length - 1) {
        $(arrowNext).addClass('hidden');
      } else {
        $(arrowNext).removeClass('hidden');
      }
    });

    slider.on('active move resized', updateHeight);

    slider.mount();

    $(window).on('resize', () => {
      updateHeight();
    });
  };

  Drupal.behaviors.mstFullWidthCarousel = {
    attach: (context) => {
      $('.full-width-carousel', context).each((index, element) => {
        const splideNumber = `full-width-carousel-${index}`;
        $(element).addClass(splideNumber);
        $(element).attr('id', splideNumber);
        initFullWidthCarousel(`.${splideNumber}`);
      });
    },
  };
})(jQuery, Drupal);
